import { Navigate, useLocation, useParams, useSearchParams } from "react-router-dom"

// PRD-58 §FR-1.5 — the standalone grades page (`/calificaciones`) is gone;
// results live on the material, the roster and the student. Both old paths
// redirect for at least one release (url-conventions.md §Migrations) so
// bookmarks, notification emails and shared links keep resolving.

// `/calificaciones/revisar/:materialId` → `/materiales/:materialId/revision`,
// query string intact (`?upload`, `?solo` deep-link into the queue).
export function LegacyReviewRedirect() {
  const { materialId } = useParams<{ materialId: string }>()
  const { search } = useLocation()
  if (!materialId) return <Navigate to="/materiales" replace />
  return <Navigate to={`/materiales/${materialId}/revision${search}`} replace />
}

// `/calificaciones?material_id=X` → the material; any other classroom-scoped
// view → that roster; nothing to go on → the materials list.
export function LegacyGradesRedirect() {
  const [params] = useSearchParams()
  const materialId = params.get("material_id")
  const classroomId = params.get("classroom")
  if (materialId) return <Navigate to={`/materiales/${materialId}`} replace />
  if (classroomId) return <Navigate to={`/salones/${classroomId}/alumnos`} replace />
  return <Navigate to="/materiales" replace />
}
